import {FC} from 'react'

type Props = {
  two_steps?: boolean
}

const RequestTwoStepsCell: FC<Props> = ({two_steps}) => (
  <> {two_steps && <div className='badge badge-warning fs-5 fw-bolder'>Pending</div>}</>
)

export {RequestTwoStepsCell}
